import React, { useRef, useEffect } from "react";
import styles from "./CommonComponents.module.css";

// Reusable ReadOnlyField Component
export const ReadOnlyField = ({ label, value }) => (
  <div className={styles.formRow}>
    <label className={styles.fieldLabel}>{label}</label>
    <div className={styles.readOnlyField}>{value}</div>
  </div>
);

export const ReadOnlyTextArea = ({ label, value }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      // Reset height to auto to calculate the correct height
      textareaRef.current.style.height = "auto";

      // Get computed styles to account for padding and border
      const computedStyle = window.getComputedStyle(textareaRef.current);
      const paddingTop = parseFloat(computedStyle.paddingTop);
      const paddingBottom = parseFloat(computedStyle.paddingBottom);
      const borderTop = parseFloat(computedStyle.borderTopWidth);
      const borderBottom = parseFloat(computedStyle.borderBottomWidth);

      // Calculate total vertical spacing
      const verticalSpacing =
        paddingTop + paddingBottom + borderTop + borderBottom;

      // Set height based on scroll height plus padding/border
      textareaRef.current.style.height = `${
        textareaRef.current.scrollHeight + verticalSpacing
      }px`;
    }
  }, [value]);

  return (
    <div className={styles.formRow}>
      {label && <label className={styles.fieldLabel}>{label}</label>}
      <textarea
        ref={textareaRef}
        className={styles.readOnlyTextArea}
        value={value || ""}
        readOnly
      />
    </div>
  );
};

// Reusable Message Component
export const Message = ({ text, type }) =>
  text ? (
    <div
      className={`${styles.message} ${
        type === "error" ? styles.error : styles.success
      }`}
    >
      {text}
    </div>
  ) : null;
